import React from "react";
const ArrowDown = ({
  customClass
}) => {
  return /*#__PURE__*/React.createElement("svg", {
    className: `${customClass ? customClass : ""}`,
    xmlns: "http://www.w3.org/2000/svg",
    width: "11",
    height: "8",
    viewBox: "0 0 11 8"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    className: `${customClass ? customClass + "-fill" : ""}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.9 4.7C-2.6 5.1-2 5.1-1.6 4.8L-1.5 4.7 3.2 0 -1.5-4.7C-1.9-5.1-2.5-5.1-2.9-4.7 -3.3-4.3-3.3-3.8-3-3.4L-2.9-3.3 0.4 0 -2.9 3.3C-3.3 3.7-3.3 4.2-3 4.6L-2.9 4.7Z",
    transform: "translate(-1 -2.5)translate(6.207107 6)scale(1 -1)"
  }))));
};
export default ArrowDown;